import { StdResponse, bimAxios } from "@/config/axios";


export function getGlobalDevices(params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/global-devices`, {
        params: {
            ...params,
        }
    })
}